var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var ApiClient_1;
import { HttpException } from '@rdss/exceptions';
import { StatusCodes } from 'http-status-codes';
import qs from 'qs';
import { container, injectable } from 'tsyringe';
let ApiClient = ApiClient_1 = class ApiClient {
    /**
     * Creates an instance of ApiClient.
     *
     * @param {ClientConfig} config - The client config.
     */
    constructor(config) {
        var _a, _b;
        this.config = config;
        /**
         * Sends a get request.
         */
        this.get = (route, id, query, init) => {
            return this.fetch('GET', route, id, undefined, query, init);
        };
        /**
         * Sends a delete request.
         */
        this.delete = (route, id) => {
            return this.fetch('DELETE', route, id, undefined);
        };
        /**
         * Sends a delete request.
         */
        this.deleteWithBody = (route, query) => {
            return this.fetch('DELETE', route, undefined, query);
        };
        /**
         * Sends a patch request.
         *
         * @example patch('products', 1099, { name: 'Product name' })
         */
        this.patch = (route, data, id, query) => this.fetch('PATCH', route, id, data, query);
        /**
         * Sends a put request because new api endpoint requires put instead of patch.
         *
         * @example put('products', 1099, { name: 'Product name' })
         */
        this.put = (route, data, id, query) => this.fetch('PUT', route, id, data, query);
        /**
         * Sends a post request.
         *
         * @param {string} route
         * @param {object} body
         */
        this.post = (route, body) => this.fetch('POST', route, undefined, body);
        /**
         * Fetches the request.
         */
        this.fetch = async (method = 'GET', route, id, body, query, init) => {
            const headers = await this.prepareHeaders(init === null || init === void 0 ? void 0 : init.headers);
            const requestInput = this.prepareRequestInput(route, id, query);
            const response = await fetch(requestInput, Object.assign(Object.assign({ method, body: JSON.stringify(body), mode: this.config.mode }, init), { headers }));
            return this.handleResponse(response, requestInput);
        };
        /**
         * Merges the default headers with the given headers.
         */
        this.prepareHeaders = async (headers = {}, { auth, csrfToken, session, } = this.config) => Object.assign({
            'Accept': 'application/hal+json,application/problem+json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        }, csrfToken && { 'X-CSRF-Token': csrfToken }, auth && { 'Authorization': auth }, session && { 'Cookie': `${session.name}=${session.value}` }, headers);
        (_a = config.protocol) !== null && _a !== void 0 ? _a : (config.protocol = 'https');
        (_b = config.requestTimeout) !== null && _b !== void 0 ? _b : (config.requestTimeout = 20000);
        config.uri = `${config.protocol}://${config.host}`;
        this.platform = config.platform;
        config.queryOptions = Object.assign({ arrayFormat: 'brackets' }, config.queryOptions);
    }
    /**
     * Prepares the request input.
     *
     * @param {string} route - The route to the resource.
     * @param {NumberOrString} id - The id of the resource.
     * @param {RequestQuery} query - The query Parameters.
     *
     * @returns {string} - The composed request route.
     */
    prepareRequestInput(route, id, query) {
        const { uri, queryOptions } = this.config;
        const url = new URL(`${uri}/${route}`);
        this.setPaginationParams(query);
        url.pathname += id ? `/${id}` : '';
        const mappedQuery = this.mapQueryShortNames(query);
        url.search = qs.stringify(mappedQuery, queryOptions);
        // ensures that the request uses the same protocol as the current browser location
        url.protocol = window.location.protocol;
        return url.href;
    }
    /**
     * Map Query params to short names.
     */
    mapQueryShortNames(query) {
        var _a, _b;
        const mappedQuery = Object.assign({}, query); // Clone object of query.
        if (query === null || query === void 0 ? void 0 : query.filter) {
            mappedQuery.f = {};
            delete mappedQuery.filter;
        }
        if ((_a = query === null || query === void 0 ? void 0 : query.filter) === null || _a === void 0 ? void 0 : _a.categories) {
            mappedQuery.f.c = query.filter.categories;
        }
        if ((_b = query === null || query === void 0 ? void 0 : query.filter) === null || _b === void 0 ? void 0 : _b.brands) {
            mappedQuery.f.b = query.filter.brands;
        }
        if (query === null || query === void 0 ? void 0 : query.filter) {
            // Filter Values Mapping.
            for (const key of Object.keys(query.filter)) {
                if (key.startsWith('p') ||
                    key.startsWith('b') ||
                    key.startsWith('ac') ||
                    key.startsWith('lp')) {
                    mappedQuery.f[key] = query.filter[key];
                }
            }
        }
        return Object.assign({}, mappedQuery);
    }
    /**
     * Sets the pagination parameters.
     */
    setPaginationParams(query) {
        var _a, _b;
        if ((_a = query === null || query === void 0 ? void 0 : query.pagination) === null || _a === void 0 ? void 0 : _a.objectsPerPage)
            query.objectsPerPage = query.pagination.objectsPerPage;
        if ((_b = query === null || query === void 0 ? void 0 : query.pagination) === null || _b === void 0 ? void 0 : _b.page)
            query.page = query.pagination.page;
        if (query === null || query === void 0 ? void 0 : query.pagination)
            delete query.pagination;
    }
    /**
     * Translation Mapped.
     */
    translationMapper(translationResponse) {
        const translations = {};
        for (const entry of translationResponse) {
            delete entry._links;
            delete entry._embedded;
            if (Object.keys(entry).length > 0) {
                const namespace = Object.keys(entry)[0];
                for (const nsEntry of entry[namespace]) {
                    if (translations[namespace] === undefined) {
                        translations[namespace] = {};
                    }
                    translations[namespace][nsEntry.name] = nsEntry.value;
                }
            }
        }
        return translations;
    }
    /**
     * Checks if the request was successful and returns the body as json object.
     */
    async handleResponse(res, requestInput) {
        var _a, _b;
        const isForbidden = res.status === StatusCodes.FORBIDDEN;
        const hasFailed = !res.ok;
        if (hasFailed || isForbidden) {
            const text = await res.text();
            throw new HttpException([
                text,
                `Request-URL: ${requestInput}`,
            ].join('\n'), res.status);
        }
        if (res.status === StatusCodes.NO_CONTENT) {
            return;
        }
        const { ok, status } = res;
        let data;
        try {
            data = (_a = await res.json()) !== null && _a !== void 0 ? _a : {};
        }
        catch (e) {
            console.error('API CLIENT JSON PARSE ERROR: ', e);
            data = {};
        }
        /* Map Translations */
        if ((_b = data === null || data === void 0 ? void 0 : data._embedded) === null || _b === void 0 ? void 0 : _b.translations) {
            data._embedded.translations = this.translationMapper(data._embedded.translations);
        }
        if (res.url.includes('/translations/')) {
            const remappedTranslations = this.translationMapper([data]);
            for (const key of Object.keys(remappedTranslations)) {
                data[key] = remappedTranslations[key];
            }
        }
        return Object.assign(Object.assign({}, data), { ok, status });
    }
};
/**
 * Creates a new instance of the client.
 *
 * @example
 * ApiClient.create({
 *   host: 'https://my-host.de'
 * })
 *
 * @param {ClientConfig} config
 */
ApiClient.create = (config) => container.register(ApiClient_1, { useValue: new ApiClient_1(config) });
ApiClient = ApiClient_1 = __decorate([
    injectable()
    /**
     * The RDSS Api client.
     *
     * @example
     *
     * Create the instance:
     *
     * ApiClient.create({
     *     uri: 'https://shop.rdss.it',
     * })
     */
    ,
    __metadata("design:paramtypes", [Object])
], ApiClient);
export { ApiClient };
//# sourceMappingURL=api-client.js.map